import React, {Component} from "react";
import App from "./App";

import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ScrollContext} from "react-router-scroll-4";

import Thanks from "./Home/Thanks";
import Cookies from "./Global/Cookies";
import About from "./About/About";

class ModilectRouter extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/">
                        <ScrollContext>
                            <App/>
                        </ScrollContext>
                    </Route>
                    <Route exact path="/about">
                        <ScrollContext>
                            <About/>
                        </ScrollContext>
                    </Route>
                    <Route exact path="/thanks">
                        <ScrollContext>
                            <Thanks/>
                        </ScrollContext>
                    </Route>
                    <Route exact path="/cookies">
                        <ScrollContext>
                            <Cookies/>
                        </ScrollContext>
                    </Route>
                    <Route>
                        <ScrollContext>
                            <App/>
                        </ScrollContext>
                    </Route>
                </Switch>
            </Router>
        );
    }
}

export default ModilectRouter;


// WEBPACK FOOTER //
// ./src/ModilectRouter.js